import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { OrderHistoryService } from './order-history.service';
import { OrderData } from './order-history.model';

export class OrderHistoryDataSource implements DataSource<OrderData> {

  private dataSubject = new BehaviorSubject<OrderData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private orderHistoryService: OrderHistoryService) {}

  connect(collectionViewer: CollectionViewer): Observable<OrderData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadOrderHistory(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'orderSequence',
    sortDirection: string = 'asc',
    filter: string = '',
    filterType: string
  ) {

    this.loadingSubject.next(true);

    this.orderHistoryService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter,
        filterType
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.order_history);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
